enum DialogName {
  Edit = 'edit',
  AddContacts = 'addContacts',
  RemoveContacts = 'removeContacts',
  CreateBookingService = 'createBookingService',
  UpdateProvider = 'updateProvider',
  CREATE_METADATA_CONFIRMATION = 'createMetadataConfirmation',
  UPDATE_METADATA_CONFIRMATION = 'updateMetadataConfirmation',
  ADD_ATOMS_CONFIRMATION = 'addAtomsConfirmation',
  UPDATE_ATOMS = 'updateAtoms',
  UPDATE_ATOMS_CLOSE_CONFIRMATION = 'updateAtomsCloseConfirmation',
  UPDATE_ATOMS_REVIEW = 'updateAtomsReview',
  REMOVE_INVENTORY_ITEMS_CONFIRMATION = 'removeInventoryItemsConfirmation',
  DeleteCustomer = 'deleteCustomer',
  CreateCustomer = 'createCustomer',
  EditCustomer = 'editCustomer',
  DiscardChanges = 'discardChanges',
  SaveOrder = 'saveOrder',
  CreatePayment = 'createPayment',
  IssueRefund = 'issueRefund',
  IssueRefundConfirmation = 'issueRefundConfirmation',
  AddPaymentProcessor = 'addPaymentProcessor',
  EditPaymentProcessor = 'editPaymentProcessor',
  ViewApiKey = 'viewApiKey',
  VoidTransactionConfirmation = 'voidTransactionConfirmation',
  VoidTransactionErrors = 'voidTransactionErrors',
  CreateMetadata = 'createMetadata',
  UpdateProduct = 'updateProduct',
  UpdateProductVariants = 'updateProductVariants',
  ManageContact = 'manageContact',
  EditUser = 'editUser',
  CreateUser = 'createUser',
  DeleteUser = 'deleteUser',
  EnableUser = 'enableUser',
  ScheduleQueues = 'scheduleQueues',
  CancelQueues = 'cancelQueues',
  SubmitQueues = 'submitQueues',
  SubmitAllQueues = 'submitAllQueues',
  ConfirmOrder = 'confirmOrder',
  UpdateInventoryItems = 'updateInventoryItems',
  ReviewInventoryItems = 'reviewInventoryItems',
  ConfirmCloseUpdateInventoryItems = 'confirmCloseUpdateInventoryItems',
  AddTile = 'addTile',
  TileConfig = 'tileConfig',
  SearchProductNotFound = 'searchProductNotFound',
  AssignCustomer = 'assignCustomer',
  ManageShippingProvider = 'manageShippingProvider',
  CreateEditShippingProfileDialog = 'createEditShippingProfileDialog',
  CloseConfirmationDialog = 'closeConfirmationDialog',
  Error = 'error',
  AssignProducts = 'assignProducts',
  ConfirmationRemoveAssignedVariants = 'confirmationRemoveAssignedVariants',
  AddZone = 'addZone',
  ConfirmationRemoveZones = 'confirmationRemoveZones',
  CashPayment = 'cashPayment',
  ExternalTerminalPayment = 'externalTerminalPayment',
  CancelOrder = 'cancelOrder',
  MapInventoryToProduct = 'mapInventoryToProduct',
  UnMapInventoryToProduct = 'unMapInventoryToProduct',
  Notes = 'notes',
  SubmitToFulfilment = 'submitToFulfilment',
  ShipToCustomer = 'shipToCustomer',
  PushToQueue = 'pushToQueue',
  AddDiscount = 'addDiscount',
  CancelSubmitToFulfilment = 'cancelSubmitToFulfilment',
}

export default DialogName;
